import { VFC, useMemo } from 'react'
import { PopUpMenu } from 'src/components/PopUp/PopUpMenu'
import { TooltipWrapper } from 'src/components/Tooltip'
import { ScheduledMessage } from 'src/models/Message'
import { _mymessage, _mymessagebg } from 'src/styles/colors'
import { fontWeightMedium } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import styled, { css } from 'styled-components'
import { MESSAGE_DATE_FORMAT } from './common'
import { Content } from './Content'
import {
  ContentContainer,
  MessageBottom,
  MessageDiv,
  Timestamp,
} from './styles'
import { MessageBaseProps } from './types'

export type MyMessageProps = MessageBaseProps & {
  isGroup: boolean
  onDelete?: VoidFunction
}
const MyMessageComponent: VFC<MyMessageProps> = ({
  message,
  onDelete,
  className,
  setPreviewImage,
  isGroup,
}) => {
  const actions = useMemo(() => {
    return onDelete ? [{ label: '送信取り消し', onClick: onDelete }] : []
  }, [onDelete])

  return (
    <MyMessageDiv className={className}>
      <div>
        <ContentContainer>
          <Content
            content={message.content}
            deleted={message.deleted}
            setPreviewImage={setPreviewImage}
          />
          {!message.deleted && (
            <>
              {actions.length > 0 && (
                <MenuDiv>
                  <PopUpMenu actions={actions} />
                </MenuDiv>
              )}
              {message.readCount > 0 &&
                ('readCompanyNames' in message &&
                message.readCompanyNames &&
                message.readCompanyNames.length > 0 ? (
                  <TooltipWrapper
                    direction={{ x: 'left', y: 'top' }}
                    tooltipStyle={readTooltipStyle}
                    tooltipNode={
                      <>
                        {message.readCompanyNames?.map((each) => (
                          <p key={each}>{each}</p>
                        ))}
                      </>
                    }
                  >
                    <ReadMarker>既読{isGroup && message.readCount}</ReadMarker>
                  </TooltipWrapper>
                ) : (
                  <ReadMarker>既読</ReadMarker>
                ))}
            </>
          )}
        </ContentContainer>
      </div>
      <MessageBottom>
        <Timestamp>{message.sentAt.format(MESSAGE_DATE_FORMAT)}</Timestamp>
      </MessageBottom>
    </MyMessageDiv>
  )
}

export const MyMessage = styled(MyMessageComponent)``

type MyScheduledMessageProps = Omit<MessageBaseProps, 'message'> & {
  message: ScheduledMessage
  onDelete: VoidFunction
  onUpdate: VoidFunction
}
const MyScheduledMessageComponent: VFC<MyScheduledMessageProps> = ({
  message,
  onDelete,
  onUpdate,
  className,
  setPreviewImage,
}) => {
  return (
    <MyMessageDiv className={className} scheduled>
      <div>
        <ContentContainer>
          <Content
            content={message.content}
            setPreviewImage={setPreviewImage}
          />
          <MenuDiv>
            <PopUpMenu
              actions={[
                { label: '送信内容を編集', onClick: onUpdate },
                { label: '予約送信を取消', onClick: onDelete },
              ]}
            />
          </MenuDiv>
        </ContentContainer>
      </div>
      <MessageBottom>
        <Timestamp>
          {message.scheduledAt.format(MESSAGE_DATE_FORMAT)}送信予定
        </Timestamp>
      </MessageBottom>
    </MyMessageDiv>
  )
}
export const MyScheduledMessage = styled(MyScheduledMessageComponent)``

const readTooltipStyle = css`
  transform: translate(-6px, -18px);
  width: 140px;
`

const ReadMarker = styled.p`
  position: absolute;
  bottom: 0;
  left: -3em;
  font-size: 10px;
  font-weight: ${fontWeightMedium};
`

const MyMessageDiv = styled(MessageDiv)<{ scheduled?: boolean }>`
  justify-content: flex-end;
  ${ContentContainer} {
    min-width: unset;
  }
  ${Content} {
    width: fit-content;
    margin-left: auto;
    color: ${_mymessage};
    p {
      margin-left: auto;
      background: ${_mymessagebg};
    }
    img {
      margin-left: auto;
    }
    ${({ scheduled }) =>
      scheduled &&
      css`
        color: ${_mymessagebg};
        p {
          border: 1px solid ${_mymessagebg};
          background: ${_mymessage};
        }
      `}
  }
  ${MessageBottom} {
    left: unset;
    right: 0;
  }
`

const MenuDiv = styled.div`
  position: absolute;
  top: 0;
  left: -24px;
  bottom: 6px;
  ${flexCenter};
`
